import { __assign } from "tslib";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useEffect, useState } from "react";
import { Button, Stack, Typography } from "@mui/material";
import { FieldControl, } from "@pangeacyber/react-mui-shared";
import * as yup from "yup";
import GeneratePasswordField from "../GeneratePasswordField";
import { useCreateShareContext } from "../../hooks/context";
var UnControlledGetPasswordLinkField = function (_a) {
    var _b = _a.onValueChange, onValueChange = _b === void 0 ? function () { } : _b;
    var _c = useCreateShareContext(), password = _c.password, loading = _c.loading, setSent = _c.setSent;
    var _d = useState(), error = _d[0], setError = _d[1];
    var _e = useState(undefined), passwordError = _e[0], setPasswordError = _e[1];
    var validate = function () {
        yup
            .string()
            .trim()
            .required("Password must meet requirements")
            .isValid(password)
            .then(function (isValid) {
            if (!isValid)
                setPasswordError("Password must meet requirements");
            else
                setPasswordError(undefined);
        });
    };
    var handleSubmitValue = function () {
        if (!password || !!passwordError)
            return;
        onValueChange(password);
    };
    var onValidatePassword = function (error) {
        setError(error);
    };
    useEffect(function () {
        if (password === "") {
            setPasswordError(undefined);
            return;
        }
        if (!loading) {
            setSent(false);
            validate();
        }
    }, [password]);
    return (_jsxs(Stack, { gap: 1, width: "100%", children: [_jsx(Typography, { variant: "caption", color: "textSecondary", mt: 1, children: "Enter a password to protect access to the link" }), _jsxs(Stack, { width: "100%", direction: "row", gap: 1, sx: {
                    "& .MuiFormGroup-root": {
                        width: "calc(100% - 100px)",
                    },
                }, children: [_jsx(GeneratePasswordField, { value: password, FieldProps: {
                            disabled: loading,
                            errorCallback: onValidatePassword,
                        } }), _jsx(Button, { variant: "outlined", onClick: handleSubmitValue, disabled: !password || !!passwordError || error || loading, sx: {
                            minWidth: "100px",
                            textWrap: "nowrap",
                        }, children: loading ? "Saving..." : "Get Link" })] })] }));
};
var GetPasswordLinkField = function (props) {
    return (_jsx(FieldControl, __assign({}, props, { children: _jsx(UnControlledGetPasswordLinkField, __assign({}, props)) })));
};
export default GetPasswordLinkField;
